import { createHeadlessEditor } from "@lexical/headless";
import { $createParagraphNode, $createTextNode, $getRoot } from "lexical";

const lexicalEditor = createHeadlessEditor({
  namespace: "HeadlessEditor",
  nodes: [],
});

export function getPlainTextFromLexicalState(editorState: string | undefined | null) {
  if (!editorState) {
    return null;
  }
  const parsedEditorState = lexicalEditor.parseEditorState(editorState);

  return parsedEditorState.read(() => $getRoot().getTextContent());
}

export function getLexicalStateFromPlainText(text: string) {
  return new Promise<string>((resolve) => {
    lexicalEditor.registerUpdateListener(({ editorState }) => {
      resolve(JSON.stringify(editorState));
    });

    lexicalEditor.update(() => {
      const paragraph = $createParagraphNode();
      const textNode = $createTextNode(text);

      paragraph.append(textNode);

      $getRoot().clear().append(paragraph);
    });
  });
}
